// removed by extract-text-webpack-plugin
module.exports = {"partnerWrap":"_13a8guDu5KXs1Ll_zww9z2_0","partner":"_1jEeiLOBN6x_PdTFVFlGun_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-717c8fbb","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/components/Partners.vue
// module id = TgSQ
// module chunks = 1